'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilingCabinetIcon = function FilingCabinetIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M28 11H4c-1 0-2 1-2 2v14c0 1 1 2 2 2h24c1 0 2-1 2-2V13c0-1-1-2-2-2zm-6.375 6.625c0 1-1 2-2 2H12c-1 0-2-1-2-2V17c0-1 1-2 2-2h7.625c1 0 2 1 2 2zM30 3H2C1 3 0 4 0 5v4h32V5c0-1-1-2-2-2z' })
    );
};

exports.default = FilingCabinetIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/FilingCabinetIcon.js
// module id = 632
// module chunks = 0